import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	Button,
	Form,
	Input,
	Modal,
	Radio,
	Select,
	Slider,
	notification,
} from "antd";
import { FiArrowLeft, FiUser } from "react-icons/fi";
import config from "../../config";
import { removeStorageWhenLogout, setHtmlStorage } from "../../config/helper";
import serviceAvatar from "../../services/avatar";
import Man1 from "../../assets/img/man-1.png";
import Man2 from "../../assets/img/man-2.png";
import Woman1 from "../../assets/img/woman-1.png";
import Woman2 from "../../assets/img/woman-2.png";
import Woman3 from "../../assets/img/woman-3.png";

const ModalCustomizeAvatar = ({
	avatarID,
	avatarDetail,
	openModal,
	onClose = () => {},
	onDelete = () => {},
	typeForm,
}) => {
	const formRef = useRef();
	const navigate = useNavigate();

	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [initValue, setInitValue] = useState({
		aiName: null,
		aiSrc: null,
		aiTraits: [],
		first: 0,
		second: 0,
		third: 0,
	});

	const handleSaveAvatar = async (values) => {
		setLoading(true);
		const traits = values.aiTraits.join(", ");
		const personalityMapping = {
			first: {
				"-100": "Extremely Shy",
				"-50": "Shy",
				0: "Friendly",
				50: "Flirty",
				100: "Extremely Flirty",
			},
			second: {
				"-100": "Extremely Pessimistic",
				"-50": "Pessimistic",
				0: "Rational",
				50: "Optimistic",
				100: "Extremely Optimistic",
			},
			third: {
				"-100": "Extremely Open",
				"-50": "Open",
				0: "Ordinary",
				50: "Mysterious",
				100: "Extremely Mysterious",
			},
		};

		const newPersonal = ["first", "second", "third"]
			.map((key) => personalityMapping[key][values[key]])
			.join(" and ");

		const payload = {
			data: JSON.stringify({
				aIsrc: values.aiSrc,
				aIname: values.aiName,
				aIinterests: traits,
				aIpersonality: newPersonal,
			}),
		};

		let response;
		if (typeForm === "create") {
			response = await serviceAvatar.createAvatar(payload);
		} else {
			response = await serviceAvatar.updateAvatar(avatarID, payload);

			setTimeout(() => {
				onDelete(avatarID);
			}, config.timeout);
		}

		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				navigate("/signin");
			}, config.timeout);
		}

		if (response.httpStatus === 200) {
			notification.success({ message: "Data has been saved." });
			setHtmlStorage("dataAvatar", JSON.stringify(response.data));
			setTimeout(() => {
				navigate("/");
			}, config.timeout);
		}

		if (response.httpStatus === 500) {
			notification.error({
				message: "Something wrong, please try again in few minutes.",
			});
			setLoading(false);
		}
	};

	useEffect(() => {
		setInitValue(avatarDetail);
	}, [avatarDetail]);

	return (
		<Modal
			footer={null}
			className="profile-modal"
			open={openModal}
			onCancel={() => {
				onClose({
					avatarAddShow: false,
					avatarShow: true,
				});
			}}
			destroyOnClose
		>
			<div className="top-section">
				<div className="user-profile">
					<Button
						className="user-profile-icon"
						icon={<FiArrowLeft size={24} />}
						onClick={() => {
							onClose({
								avatarAddShow: false,
								avatarShow: true,
							});
						}}
					/>
					<div className="user-profile-wrapper">
						<span>Customize avatar</span>
						<Button
							type="link"
							loading={loading}
							onClick={() => formRef.current.submit()}
						>
							Save
						</Button>
					</div>
				</div>
				<Form
					autoComplete="off"
					layout="vertical"
					colon={false}
					requiredMark={false}
					ref={formRef}
					form={form}
					initialValues={initValue}
					onFinish={handleSaveAvatar}
				>
					<Form.Item
						label="Choose Avatar"
						name="aiSrc"
						rules={[
							{
								required: true,
								message: "Select your AI avatar!",
							},
						]}
					>
						<Radio.Group className="choose-avatar">
							<Radio value={Man1}>
								<img src={Man1} alt="Avatar Man 1" />
							</Radio>
							<Radio value={Man2}>
								<img src={Man2} alt="Avatar Man 2" />
							</Radio>
							<Radio value={Woman1}>
								<img src={Woman1} alt="Avatar Woman 1" />
							</Radio>
							<Radio value={Woman2}>
								<img src={Woman2} alt="Avatar Woman 2" />
							</Radio>
							<Radio value={Woman3}>
								<img src={Woman3} alt="Avatar Woman 3" />
							</Radio>
						</Radio.Group>
					</Form.Item>
					<Form.Item
						name="aiName"
						rules={[
							{
								required: true,
								message: "Please enter an avatar name!",
							},
						]}
					>
						<Input
							placeholder="Enter avatar name"
							prefix={<FiUser />}
						/>
					</Form.Item>
					<Form.Item label="Avatar Personalities">
						<div className="slider-wrapper">
							<Form.Item name="first">
								<Slider
									min={-100}
									max={100}
									defaultValue={0}
									step={50}
									marks={{
										"-100": "Extremely Shy",
										0: "Friendly",
										100: "Extremely Flirty",
									}}
								/>
							</Form.Item>
							<Form.Item name="second">
								<Slider
									min={-100}
									max={100}
									defaultValue={0}
									step={50}
									marks={{
										"-100": "Extremely Pessimistic",
										0: "Rational",
										100: "Extremely Optimistic",
									}}
								/>
							</Form.Item>
							<Form.Item name="third">
								<Slider
									min={-100}
									max={100}
									defaultValue={0}
									step={50}
									marks={{
										"-100": "Extremely Open",
										0: "Ordinary",
										100: "Extremely Mysterious",
									}}
								/>
							</Form.Item>
						</div>
					</Form.Item>
					<Form.Item
						name="aiTraits"
						rules={[
							{
								required: true,
								message: "Select your AI avatar interest!",
							},
						]}
					>
						<Select
							mode="multiple"
							placeholder="Select interest"
							options={[
								{
									label: "🍳 Cooking",
									value: "cooking",
								},
								{
									label: "👠 Fashion",
									value: "fashion",
								},
								{
									label: "🎤 Karaoke",
									value: "karaoke",
								},
								{ label: "🍷 Wine", value: "wine" },
								{
									label: "🎲 Board Games",
									value: "board games",
								},
								{
									label: "🏐️ Sports",
									value: "sports",
								},
								{ label: "🐕 Dogs", value: "dogs" },
								{ label: "☕ Coffee", value: "coffee" },
								{
									label: "🤳️ Instagram",
									value: "instagram",
								},
								{
									label: "💪 Working Out",
									value: "working Out",
								},
								{
									label: "♊ Astrology",
									value: "astrology",
								},
								{
									label: "📸 Photography",
									value: "photography",
								},
							]}
						/>
					</Form.Item>
				</Form>
			</div>
		</Modal>
	);
};

export default ModalCustomizeAvatar;
